/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Prereq_ResumeInputs */

const en_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a resume first.`)
};

const de_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle zuerst einen Lebenslauf.`)
};

const fr_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creez d'abord un CV.`)
};

const es_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero crea un curriculo.`)
};

const it_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea prima un CV.`)
};

const nl_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak eerst een cv.`)
};

const pl_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw utworz CV.`)
};

const fi_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ensin ansioluettelo.`)
};

const da_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret forst et CV.`)
};

const sv_cover_letters_prereq_resume = /** @type {(inputs: Cover_Letters_Prereq_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa forst ett CV.`)
};

/**
* | output |
* | --- |
* | "Create a resume first." |
*
* @param {Cover_Letters_Prereq_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_prereq_resume = /** @type {((inputs?: Cover_Letters_Prereq_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Prereq_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_prereq_resume(inputs)
	if (locale === "fr") return fr_cover_letters_prereq_resume(inputs)
	if (locale === "es") return es_cover_letters_prereq_resume(inputs)
	if (locale === "it") return it_cover_letters_prereq_resume(inputs)
	if (locale === "nl") return nl_cover_letters_prereq_resume(inputs)
	if (locale === "pl") return pl_cover_letters_prereq_resume(inputs)
	if (locale === "fi") return fi_cover_letters_prereq_resume(inputs)
	if (locale === "da") return da_cover_letters_prereq_resume(inputs)
	if (locale === "sv") return sv_cover_letters_prereq_resume(inputs)
	return en_cover_letters_prereq_resume(inputs)
});